<div class="catalogs-tab-container">
    <div class="table-container">
        <div class="table-header">
            <h2 class="table-title">Catalogs</h2>
            <span matTooltip="Workspace required for catalog creation." [matTooltipDisabled]="hasWorkspace()">
                <button mat-fab extended class="add-button" 
                        matTooltip="Add new catalog"
                        [disabled]="catalogService.isCatalogLoading() || !hasWorkspace()"
                        (click)="openAddCatalogDialog()">
                <mat-icon>add</mat-icon>Add Catalog</button>
            </span>
        </div>
        <div class="table-body">
            @if (catalogService.isCatalogLoading()) {
                <app-loading-spinner/>
            } @else if (catalogService.catalogErrorMessage() === "") {
                <table mat-table [dataSource]="catalogsDataSource" matSort class="table">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-header">Name</th>
                        <td mat-cell *matCellDef="let element">{{element.name}}</td>
                    </ng-container>

                    <ng-container matColumnDef="creationDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-header">Date Created</th>
                        <td mat-cell *matCellDef="let element" class="creation-date-column">
                            @if (element.createdAt) {
                                {{element.createdAt | date:'dd MMM yyyy, HH:mm'}}
                            } @else {
                                <span class="empty-table-field">{{"-"}}</span>
                            }
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef class="column-header"></th>
                        <td mat-cell *matCellDef="let element" class="status-coloumn">
                            <div class="icon-container">
                                <span matTooltip="Editing not yet avaliable" matTooltipDisabled="false">
                                    <button disabled mat-icon-button
                                        class="edit-button">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                </span>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="catalogsColumns ; sticky: true" class="header-row"></tr>
                    <tr mat-row *matRowDef="let row; columns: catalogsColumns;" class="row"></tr>

                    @if (hasWorkspace()) {
                        <tr class="full-row" *matNoDataRow>
                            <td [attr.colspan]="catalogsColumns.length" class="full-row-cell">
                                <div class="full-row-content">
                                    <mat-icon>info</mat-icon>
                                    <p class="not-found-message">No Catalog Found</p>
                                    <p class="not-found-sub-message">To create a catalog, click Add Catalog</p>
                                </div>
                            </td>
                        </tr>
                    } @else {
                        <tr class="full-row" *matNoDataRow>
                            <td [attr.colspan]="catalogsColumns.length" class="full-row-cell">
                                <div class="full-row-content">
                                    <mat-icon>info</mat-icon>
                                    <p class="not-found-message">Unable to Create Catalog</p>
                                    <p class="not-found-sub-message">Catalog creation requires at least one workspace</p>
                                </div>
                            </td>
                        </tr>
                    }
                </table>
            } @else {
                <tr class="error-container">
                    <mat-icon>warning</mat-icon>
                    <p class="error-message">Error: {{catalogService.catalogErrorMessage()}}</p>
                </tr>
            }
        </div>
    </div>
</div>